import { colors } from "@mui/material";
import React from "react";
import { CustomIconProps } from "./add-01-solid-standard";

const GoogleIcon: React.FC<CustomIconProps> = ({
  size = 48,
  color = "#000000",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    color={color}
    fill={"none"}
    {...props}
  >
    <g clip-path="url(#clip0_2406_25)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M47.04 24.5454C47.04 22.8436 46.8873 21.2073 46.6036 19.6364H24V28.92H36.9164C36.36 31.92 34.6691 34.4618 32.1273 36.1636V42.1854H39.8836C44.4218 38.0073 47.04 31.8545 47.04 24.5454Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24 47.9998C30.48 47.9998 35.9127 45.8507 39.8836 42.1853L32.1273 36.1634C29.9782 37.6034 27.2291 38.4544 24 38.4544C17.7491 38.4544 12.4582 34.2325 10.5709 28.5598H2.55272V34.778C6.50181 42.6216 14.6182 47.9998 24 47.9998Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5709 28.5597C10.0909 27.1197 9.81818 25.5816 9.81818 23.9997C9.81818 22.4179 10.0909 20.8797 10.5709 19.4397V13.2216H2.55273C0.927273 16.4616 0 20.127 0 23.9997C0 27.8725 0.927273 31.5379 2.55273 34.7779L10.5709 28.5597Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24 9.54545C27.5236 9.54545 30.6873 10.7564 33.1745 13.1345L40.0582 6.25091C35.9018 2.37818 30.4691 0 24 0C14.6182 0 6.50181 5.37818 2.55272 13.2218L10.5709 19.44C12.4582 13.7673 17.7491 9.54545 24 9.54545Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2406_25">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default GoogleIcon;
